import { render } from "./AgentePickDepto.vue?vue&type=template&id=c1401940"
import script from "./AgentePickDepto.vue?vue&type=script&lang=ts"
export * from "./AgentePickDepto.vue?vue&type=script&lang=ts"
script.render = render

export default script